<section class="bg-light h-100">
  <div class="container d-flex w-100 h-100">
    <div class="row d-flex justify-content-center align-items-center w-100 p-4">
      <div class="col-lg-8 col-xl-10">
        <div class="card text-black" style="border-radius: 25px">
          <div class="card-body">
            <div class="row justify-content-center">
              <div class="col-md-10 col-lg-6 col-xl-5 order-2 order-lg-1">
                <p class="text-left h1 fw-bold mb-5 mx-1 mx-md-4 mt-4">
                  Sign up
                </p>

                <form
                  class="mx-1 mx-md-4"
                  [formGroup]="signupForm"
                  (ngSubmit)="submit()"
                >
                  <div class="d-flex flex-row align-items-center mb-4">
                    <div class="form-outline flex-fill mb-0">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Name"
                        formControlName="name"
                      />
                      <div
                        class="text-danger"
                        *ngIf="submitted && signupForm.get('name')?.errors"
                      >
                        <small *ngIf="signupForm.get('name')?.errors?.required"
                          >Name is required</small
                        >
                        <small *ngIf="signupForm.get('name')?.errors?.minLength"
                          >Name must be at least of 3 characters</small
                        >
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-row align-items-center mb-4">
                    <div class="form-outline flex-fill mb-0">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Last name"
                        formControlName="lastName"
                      />
                      <div
                        class="text-danger"
                        *ngIf="submitted && signupForm.get('lastName')?.errors"
                      >
                        <small
                          *ngIf="signupForm.get('lastName')?.errors?.required"
                          >Lastname is required</small
                        >
                        <small
                          *ngIf="signupForm.get('lastName')?.errors?.minlength"
                          >LastName must be at least of 3 characters
                        </small>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex flex-row align-items-center mb-4">
                    <div class="form-outline flex-fill mb-0">
                      <input
                        type="email"
                        placeholder="Email"
                        class="form-control"
                        formControlName="email"
                      />
                      <div
                        class="text-danger"
                        *ngIf="submitted && signupForm.get('email')?.errors"
                      >
                        <small *ngIf="signupForm.get('email')?.errors?.required"
                          >Email is required</small
                        >
                        <small *ngIf="signupForm.get('email')?.errors?.email"
                          >Email must be valid</small
                        >
                      </div>
                    </div>
                  </div>

                  <div class="d-flex flex-row align-items-center mb-4">
                    <div class="form-outline flex-fill mb-0">
                      <input
                        type="password"
                        class="form-control"
                        placeholder="Password"
                        formControlName="password"
                      />
                      <div
                        class="text-danger"
                        *ngIf="submitted && signupForm.get('password')?.errors"
                      >
                        <small
                          *ngIf="signupForm.get('password')?.errors?.required"
                          >Passaword is required</small
                        >
                        <small
                          *ngIf="signupForm.get('password')?.errors?.minlength"
                          >Password must be at least of 8 length</small
                        >
                      </div>
                    </div>
                  </div>

                  <div class="d-flex flex-row align-items-center mb-4">
                    <div class="form-outline flex-fill mb-0">
                      <input
                        type="password"
                        class="form-control"
                        placeholder="Repeat your password"
                        formControlName="confirmPassword"
                      />
                      <div
                        class="text-danger"
                        *ngIf="
                          submitted && signupForm.get('confirmPassword')?.errors
                        "
                      >
                        <small
                          *ngIf="
                            signupForm.get('confirmPassword')?.errors?.required
                          "
                          >Confirm Password is required</small
                        >
                        <small
                          *ngIf="
                            signupForm.get('confirmPassword')?.errors?.minlength
                          "
                          >Confirm password must be at least of 8
                          characters</small
                        >
                      </div>
                      <div class="text-danger">
                        <small
                          *ngIf="
                            signupForm.get('confirmPassword')?.errors ===
                              null &&
                            signupForm.get('confirmPassword')?.value !=
                              signupForm.get('password')?.value
                          "
                          >Confirm password must be equal to password</small
                        >
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="submitted && validationEmailSent"
                    class="text-primary mb-2"
                  >
                    Verification email has been sent to your account
                  </div>
                  <div *ngIf="submitted && error" class="text-danger mb-2">
                    Error while adding your account
                  </div>

                  <div class="d-flex flex-row mb-4">
                    <button type="submit" class="btn btn-primary btn-lg">
                      Register
                    </button>
                  </div>
                  <div class="d-flex flex-row align-items-center">
                    <div
                      class="mt-3 fw-bold"
                      role="button"
                      (click)="redirectToLogin()"
                    >
                      Back to login
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
